export type CsvCell = string | number | boolean | null | undefined | Date

function normalizeCell(v: CsvCell): string {
  if (v == null) return ''
  if (v instanceof Date) return v.toISOString()
  return String(v)
}

// RFC4180系: , " 改行が含まれる場合は "..." で囲い、" は "" にする
export function toCsv(rows: CsvCell[][]): string {
  return rows
    .map((row) =>
      row
        .map((cell) => {
          const s = normalizeCell(cell)
          const needsQuote = /[",\r\n]/.test(s)
          const escaped = s.replace(/"/g, '""')
          return needsQuote ? `"${escaped}"` : escaped
        })
        .join(',')
    )
    .join('\r\n')
}

export function downloadTextFile(
  filename: string,
  text: string,
  mime = 'text/csv;charset=utf-8;'
) {
  const blob = new Blob([text], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
